import { gql } from '@apollo/client'

export const Query = gql`
  query CustomFieldValueOptions($companyId: ID!, $filters: CustomFieldFilters) {
    customFields(companyId: $companyId, filters: $filters) {
      nodes {
        id
        name
        fieldType
        options {
          id
          value
        }
      }
    }
  }
`
